// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const l = require('app/scripts/lib/localize');

module.exports = {
  BOARD_NAME: 'board-name',
  LIST_NAME: 'list-name',
  CARD_NAME: 'card-name',
  CHECKITEM_NAME: 'check-name',
  CARD_DRAG: 'card-drag',
  translatedCardDragFileMap: {
    cs: require('resources/images/create-first-board/card-drag/cs-card-drag.gif'),
    de: require('resources/images/create-first-board/card-drag/de-card-drag.gif'),
    en: require('resources/images/create-first-board/card-drag/en-card-drag.gif'),
    es: require('resources/images/create-first-board/card-drag/es-card-drag.gif'),
    fi: require('resources/images/create-first-board/card-drag/fi-card-drag.gif'),
    fr: require('resources/images/create-first-board/card-drag/fr-card-drag.gif'),
    hu: require('resources/images/create-first-board/card-drag/hu-card-drag.gif'),
    it: require('resources/images/create-first-board/card-drag/it-card-drag.gif'),
    ja: require('resources/images/create-first-board/card-drag/ja-card-drag.gif'),
    nb: require('resources/images/create-first-board/card-drag/nb-card-drag.gif'),
    nl: require('resources/images/create-first-board/card-drag/nl-card-drag.gif'),
    pl: require('resources/images/create-first-board/card-drag/pl-card-drag.gif'),
    'pt-br': require('resources/images/create-first-board/card-drag/pt-br-card-drag.gif'),
    ru: require('resources/images/create-first-board/card-drag/ru-card-drag.gif'),
    sv: require('resources/images/create-first-board/card-drag/sv-card-drag.gif'),
    th: require('resources/images/create-first-board/card-drag/th-card-drag.gif'),
    tr: require('resources/images/create-first-board/card-drag/tr-card-drag.gif'),
    uk: require('resources/images/create-first-board/card-drag/uk-card-drag.gif'),
    vi: require('resources/images/create-first-board/card-drag/vi-card-drag.gif'),
    'zh-hans': require('resources/images/create-first-board/card-drag/zh-hans-card-drag.gif'),
    'zh-hant': require('resources/images/create-first-board/card-drag/zh-hant-card-drag.gif'),
  },
  translatedCardBackFileMap: {
    cs: require('resources/images/create-first-board/card-back/cardBack-cs.svg'),
    de: require('resources/images/create-first-board/card-back/cardBack-de.svg'),
    en: require('resources/images/create-first-board/card-back/cardBack-en.svg'),
    es: require('resources/images/create-first-board/card-back/cardBack-es.svg'),
    fi: require('resources/images/create-first-board/card-back/cardBack-fi.svg'),
    fr: require('resources/images/create-first-board/card-back/cardBack-fr.svg'),
    hu: require('resources/images/create-first-board/card-back/cardBack-hu.svg'),
    it: require('resources/images/create-first-board/card-back/cardBack-it.svg'),
    ja: require('resources/images/create-first-board/card-back/cardBack-ja.svg'),
    nb: require('resources/images/create-first-board/card-back/cardBack-nb.svg'),
    nl: require('resources/images/create-first-board/card-back/cardBack-nl.svg'),
    pl: require('resources/images/create-first-board/card-back/cardBack-pl.svg'),
    'pt-br': require('resources/images/create-first-board/card-back/cardBack-pt-br.svg'),
    ru: require('resources/images/create-first-board/card-back/cardBack-ru.svg'),
    sv: require('resources/images/create-first-board/card-back/cardBack-sv.svg'),
    th: require('resources/images/create-first-board/card-back/cardBack-th.svg'),
    tr: require('resources/images/create-first-board/card-back/cardBack-tr.svg'),
    uk: require('resources/images/create-first-board/card-back/cardBack-uk.svg'),
    vi: require('resources/images/create-first-board/card-back/cardBack-vi.svg'),
    'zh-hans': require('resources/images/create-first-board/card-back/cardBack-zh-hans.svg'),
    'zh-hant': require('resources/images/create-first-board/card-back/cardBack-zh-hant.svg'),
  },
  getInitialData(selectedVertical) {
    return {
      name: '',
      checkItem: '',
      defaultValue: l([
        'templates',
        'onboarding',
        `board-name:${selectedVertical}:title`,
      ]),
      lists: [
        {
          name: l([
            'templates',
            'onboarding',
            `list-name:${selectedVertical}:placeholder:0`,
          ]),
          cards: [
            {
              name: '',
              large: false,
              defaultValue: l([
                'templates',
                'onboarding',
                `card-name:${selectedVertical}:placeholder:0`,
              ]),
            },
            {
              name: '',
              large: false,
            },
            {
              name: '',
              large: false,
            },
          ],
        },
        {
          name: l([
            'templates',
            'onboarding',
            `list-name:${selectedVertical}:placeholder:1`,
          ]),
          cards: [
            {
              name: '',
              large: true,
            },
            {
              name: '',
              large: false,
            },
            {
              name: '',
              large: true,
            },
          ],
        },
        {
          name: l([
            'templates',
            'onboarding',
            `list-name:${selectedVertical}:placeholder:2`,
          ]),
          cards: [
            {
              name: '',
              large: false,
            },
            {
              name: '',
              large: true,
            },
            {
              name: '',
              large: false,
            },
          ],
        },
      ],
    };
  },
  verticals: {
    'project-management': {
      inspirationBoards: {
        es: {
          id: '5cf0edd58b0e8642d27af86f',
          name: 'Tablero muestra para gestión de proyectos',
        },
        fr: {
          id: '5cf0f6e1cd126e02f344177b',
          name: 'Modèle de tableau pour chef de projet',
        },
        en: {
          id: '5be9e04a3c41be557c21ce12',
          name: 'Project Manager Sample Board',
        },
        de: {
          id: '5cf13eca53ba562368966718',
          name: 'Projektleiter Sample Board',
        },
        'pt-br': {
          id: '5cf0fc94c7d7310a08b9f886',
          name: 'Quadro modelo: Gestor de projetos',
        },
        ru: {
          id: '5cf100b6ee8c59195b7db839',
          name: 'Доска для Менеджмента',
        },
      },
      sortId: 0,
    },
    business: {
      inspirationBoards: {
        es: {
          id: '5cf0ec49d9cb4507b1e09f91',
          name: 'Panorama general de la empresa',
        },
        fr: {
          id: '5cf0f5018f213943a961a47b',
          name: "Compte-Rendu de l'entreprise",
        },
        en: {
          id: '5be9e0c981e2a24e668677d4',
          name: 'Company Overview',
        },
        de: {
          id: '5cf0e451160ee877e8bd8e10',
          name: 'Unternehmensüberblick',
        },
        'pt-br': {
          id: '5cf0fafc53deac4f95712431',
          name: 'Visão Geral da Empresa',
        },
        ru: {
          id: '5cf0ff30896ef65e9cb2fcea',
          name: 'Обзор компании',
        },
      },
      sortId: 1,
    },
    productivity: {
      inspirationBoards: {
        es: {
          id: '5cf0ee8e1a5fc844aa70dc3b',
          name: 'La mejor lista de pendientes de todas',
        },
        fr: {
          id: '5cf0f7f14c3af93937d5e64a',
          name: 'La Parfaite ToDo',
        },
        en: {
          id: '5be9e17f7f59e38086d6862e',
          name: 'Ultimate To-Do List',
        },
        de: {
          id: '5cf0ea256e766c2db7923704',
          name: 'Ultimative To-Do-Liste',
        },
        'pt-br': {
          id: '5cf0fd0c19ef79808d290236',
          name: 'Lista-mestre de tarefas',
        },
        ru: {
          id: '5cf1012b86ff2d6373f70741',
          name: 'Список дел',
        },
      },
      sortId: 2,
    },
    'engineering-it': {
      inspirationBoards: {
        es: {
          id: '5cf0edad5335fd5b502c6471',
          name: 'Flujo de trabajo para producción',
        },
        fr: {
          id: '5cf0f6734f42fe12d7a7d26e',
          name: 'Flux de travail',
        },
        en: {
          id: '5be9e19a9cca75084265ddc4',
          name: 'Production Workflow',
        },
        de: {
          id: '5cf0e8d3c65bd813244edc7f',
          name: 'Produktions-Workflow',
        },
        'pt-br': {
          id: '5cf0fc6d502d0a533c79cf8b',
          name: 'Fluxo de trabalho de produção',
        },
        ru: {
          id: '5cf1009550f67a7aa8a2780f',
          name: 'Процесс разработки',
        },
      },
      sortId: 3,
    },
    marketing: {
      inspirationBoards: {
        es: {
          id: '5cf0ecfc353ee215a35e6f65',
          name: 'Panorama general de marketing',
        },
        fr: {
          id: '5cf0f59fb4b3c0423a312a34',
          name: "Marketing - Vue d'ensemble",
        },
        en: {
          id: '5be9e1d47c41ac0e2979e745',
          name: 'Marketing Overview',
        },
        de: {
          id: '5cf0e54bb3bfd654e943c74f',
          name: 'Marketing-Überblick',
        },
        'pt-br': {
          id: '5cf0fbb531f11543239f5b5c',
          name: 'Visão Geral de Marketing',
        },
        ru: {
          id: '5cf0ffefacaf9c37ff5d1887',
          name: 'Маркетинговый обзор',
        },
      },
      sortId: 4,
    },
    education: {
      inspirationBoards: {
        es: {
          id: '5cf0ee4f8e6d6a1e64a1f3fe',
          name: 'Proyecto de investigación',
        },
        fr: {
          id: '5cf0f7af256884882e009ec3',
          name: 'Projets de Recherche - Terminale S',
        },
        en: {
          id: '5be9e0a4747e797af465cb3d',
          name: 'Student Research Board',
        },
        de: {
          id: '5cf0e9cc5a200a128dd8d621',
          name: 'Studenten-Forschungs-Board',
        },
        'pt-br': {
          id: '5cf0fcecb681c151cf2ca9bb',
          name: 'Quadro de pesquisa de estudante',
        },
        ru: {
          id: '5cf1010c61c08b4e03cca166',
          name: 'Студенческий исследовательский проект',
        },
      },
      sortId: 5,
    },
    'personal-goals': {
      inspirationBoards: {
        es: {
          id: '5cf0ecc43b45a2496ac11ebc',
          name: 'Metas de vida',
        },
        fr: {
          id: '5cf0f5629cc4ba4edf5a1191',
          name: 'Objectifs de vie',
        },
        en: {
          id: '5be9e2f37a690f713e1c0b8f',
          name: 'Life Goals',
        },
        de: {
          id: '5cf0e5084af7232e9ea0cb31',
          name: 'Lebensziele',
        },
        'pt-br': {
          id: '5cf0fb8732226c30444afe72',
          name: 'Metas de vida',
        },
        ru: {
          id: '5cf0ffcf3b7ea01a2f8d005d',
          name: 'Жизненные цели',
        },
      },
      sortId: 6,
    },
    home: {
      inspirationBoards: {
        es: {
          id: '5cf0ec928c620920b0b0b6d9',
          name: 'Quehaceres del hogar',
        },
        fr: {
          id: '5cf0f54660c11b2f98bf053d',
          name: 'Tâches ménagères',
        },
        en: {
          id: '5be9e513f7a51835e16662db',
          name: 'Household Chores',
        },
        de: {
          id: '5cf0e4d13f3b141268679ad8',
          name: 'Haushaltsaufgaben',
        },
        'pt-br': {
          id: '5cf0fb5b5ad3a380f72a9ba4',
          name: 'Tarefas Domésticas',
        },
        ru: {
          id: '5cf0ffb508f9ef2e909c8710',
          name: 'Работа по дому',
        },
      },
    },
    'event-planning': {
      inspirationBoards: {
        es: {
          id: '5cf0ec6208f9ef2e9098f591',
          name: 'Planificación de un evento',
        },
        fr: {
          id: '5cf0f5251342527f518c6025',
          name: "Organisation d'évènement",
        },
        en: {
          id: '5be9e35e20e1991c0cede0a5',
          name: 'Event Planning',
        },
        de: {
          id: '5cf0e47f4969530304e8b595',
          name: 'Eventplanung',
        },
        'pt-br': {
          id: '5cf0fb2c1508cc8265134c15',
          name: 'Organização de Eventos',
        },
        ru: {
          id: '5cf0ff8c01145e2416013210',
          name: 'Планировка событий',
        },
      },
    },
    'creative-arts': {
      inspirationBoards: {
        es: {
          id: '5cf0ed7e2d110b0798f4b5d7',
          name: 'Flujo de trabajo para podcast editorial',
        },
        fr: {
          id: '5cf0f622a5dd2c21ac3b7593',
          name: 'Podcast - Organisation Production',
        },
        en: {
          id: '5be9e1fd2dc2b5715a4546f5',
          name: 'Podcast Editorial Workflow',
        },
        de: {
          id: '5cf0e89be43a5d732a0340a7',
          name: 'Podcast Editorial Workflow',
        },
        'pt-br': {
          id: '5cf0fc3de3778f1cec051b34',
          name: 'Fluxo de trabalho: Editorial de podcast',
        },
        ru: {
          id: '5cf100657cac0f5381ca933e',
          name: 'Подкасты - Редакционный процесс',
        },
      },
    },
    'sales-crm': {
      inspirationBoards: {
        es: {
          id: '5cf0ee1faabd8607d43d6d22',
          name: 'Ventas – pipeline en el CRM',
        },
        fr: {
          id: '5cf0f78860c11b2f98bf77ef',
          name: 'Pipeline de CRM - Ventes',
        },
        en: {
          id: '5be9e3df58d5bc1ede20bf7f',
          name: 'Sales CRM Pipeline',
        },
        de: {
          id: '5cf0e965328c1e779d1657cb',
          name: 'Vertriebs-CRM-Pipeline',
        },
        'pt-br': {
          id: '5cf0fcb9a5313020a64aea3f',
          name: 'Pipeline de Vendas – CRM',
        },
        ru: {
          id: '5cf100e2ea54dd72a823f1c4',
          name: 'Продажи',
        },
      },
    },
    support: {
      inspirationBoards: {
        es: {
          id: '5cf0ec19f16d2a203ac8d40e',
          name: 'Reportes de errores de código',
        },
        fr: {
          id: '5cf0f4dd07324149e9ed39e3',
          name: "Rapports d'erreur",
        },
        en: {
          id: '5be9e328f0697318045cc0d3',
          name: 'Bug Report',
        },
        de: {
          id: '5cf05f90ee316842fc85837a',
          name: 'Fehlerberichte',
        },
        'pt-br': {
          id: '5cf0faceaf9bcd2ebfd42691',
          name: 'Relatórios de Bugs',
        },
        ru: {
          id: '5cf0ff03a4024b8788789a53',
          name: 'Отчеты об ошибках (баги)',
        },
      },
    },
    travel: {
      inspirationBoards: {
        es: {
          id: '5cf0ed1e51be3c396b6f62f6',
          name: 'Planea tus vacaciones',
        },
        fr: {
          id: '5cf0f5e132c31f44182f0df5',
          name: 'Organiser ses vacances',
        },
        en: {
          id: '5c0180d7969dc80ef7435c2d',
          name: 'Plan A Vacation',
        },
        de: {
          id: '5cf0e81ceb484f607bb45c03',
          name: 'Urlaubsplanung',
        },
        'pt-br': {
          id: '5cf0fbd46b050a640f5da48e',
          name: 'Planejando as férias',
        },
        ru: {
          id: '5cf1000d68da2864038dfe9a',
          name: 'Планирование отпуска',
        },
      },
    },
    wedding: {
      inspirationBoards: {
        es: {
          id: '5cf0ed3ecc7cf321c0d03dc6',
          name: 'Planeando tu boda',
        },
        fr: {
          id: '5cf0f602935df603b35b97da',
          name: 'Organiser son marriage',
        },
        en: {
          id: '5be9e415ff84ad7a588c024b',
          name: 'Plan a Wedding',
        },
        de: {
          id: '5cf0e86a187d006b87167481',
          name: 'Hochzeitsplanung',
        },
        'pt-br': {
          id: '5cf0fc05368f711774e55b89',
          name: 'Planejar um casamento',
        },
        ru: {
          id: '5cf1004319aa363ff61702a2',
          name: 'Планирование свадьбы',
        },
      },
    },
    other: {
      inspirationBoards: {
        es: {
          id: '5cf0ebf7e0ad25729ce1ae2a',
          name: 'Cosas que siempre he querido hacer',
        },
        fr: {
          id: '5cf0f4b6115e5e5fe80b8f38',
          name:
            "Vivre une vie exictante : la liste ultime d'objectifs à accomplir",
        },
        en: {
          id: '5c59e4d58db1a81e59de2ec3',
          name: 'Bucket list',
        },
        de: {
          id: '5cf0e42455141c4842a12896',
          name: 'Bucket List - Löffelliste',
        },
        'pt-br': {
          id: '5cf0fa054ca17763cc24cf1a',
          name: 'Lista dos Sonhos',
        },
        ru: {
          id: '5cf0fee699294488b768ef3b',
          name: 'Мой список желаний',
        },
      },
    },
  },
};
